import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Tag, ArrowRight } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import DealsCarousel from '@/components/home/DealsCarousel';
import { Button } from '@/components/ui/button';

const Deals = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background" data-testid="deals-page">
      <Navbar />
      
      <main className="pt-24 pb-16">
        {/* Hero */}
        <section className="bg-gradient-to-r from-orange-50 to-amber-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center"
            >
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, type: 'spring' }}
                className="w-20 h-20 mx-auto mb-6 rounded-3xl gradient-secondary flex items-center justify-center"
              >
                <Tag className="w-10 h-10 text-white" />
              </motion.div>
              <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                {t('products.deals')}
              </h1>
              <p className="text-lg text-slate-600 max-w-2xl mx-auto mb-8">
                Don't miss out on our amazing limited-time offers! Fresh products at incredible prices.
              </p>
              <Link to="/category/all?sale=true">
                <Button className="btn-primary">
                  View All Deals
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
            </motion.div>
          </div>
        </section>

        {/* Deals Carousel */}
        <DealsCarousel />

        {/* CTA */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="card-glass p-8 md:p-12 text-center"
            >
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">
                Subscribe for Exclusive Deals
              </h2>
              <p className="text-slate-600 mb-6">
                Get notified about new deals and special offers directly to your inbox.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 h-12 px-4 rounded-xl border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none"
                />
                <Button className="btn-primary h-12">Subscribe</Button>
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Deals;
